export default "__VITE_ASSET__Dwg3gRDh__"